// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"67":"home-parent","145":"Logins","450":"About","845":"my-app-overview"}[chunkId] + "." + {"67":"6f5a4282","145":"c507c4a3","450":"50ebb3e3","845":"8c472e3d"}[chunkId] + ".js";
};